import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_API_URL || 'https://newalemny.3almny.app/api';

// Async thunk for submitting a lesson rating
export const submitLessonRating = createAsyncThunk(
  "ratings/submitLessonRating",
  async (ratingData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      const headers = { "Content-Type": "application/json" };
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      
      const response = await fetch(`${BASE_URL}/lessons/rate_lesson`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(ratingData)
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في إرسال التقييم");
      }
      
      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

const initialState = {
  isSubmitting: false,
  submitError: null,
  submitSuccess: false,
};

const ratingsSlice = createSlice({
  name: "ratings",
  initialState,
  reducers: {
    clearRatingError: (state) => {
      state.submitError = null;
    },
    clearRatingSuccess: (state) => {
      state.submitSuccess = false;
    },
    resetRatingState: (state) => {
      state.isSubmitting = false;
      state.submitError = null;
      state.submitSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Submit rating
      .addCase(submitLessonRating.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = null;
        state.submitSuccess = false;
      })
      .addCase(submitLessonRating.fulfilled, (state) => {
        state.isSubmitting = false;
        state.submitSuccess = true;
        state.submitError = null;
      })
      .addCase(submitLessonRating.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitError = action.payload;
        state.submitSuccess = false;
      });
  },
});

export const { clearRatingError, clearRatingSuccess, resetRatingState } = ratingsSlice.actions;

export default ratingsSlice.reducer; 